import AuthService from '../../services/AuthService';

const CheckAccess = ({ children, permission }) => (
  permission && AuthService.canDo(permission)
    ? children
    : []
);

export default CheckAccess;
